import React, { useState, useEffect } from "react";
import "./index.scss";
import { Container, Row } from "reactstrap";
import { Button } from "shared";
import ModalCreateTab from "pages/CustomField/components/ModalCreateTab";
import { connect } from "react-redux";
import api from "api";
import TabItem from "pages/CustomField/components/TabItem";
import t from "utils/Lang";
import { useHistory } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { sortNewGroup } from "utils/CustomFieldHelper";
import { TextField } from "shared";

type CustomTabsProps = {
  user?: any;
};

const CustomTabs = ({ user }: CustomTabsProps) => {
  const history = useHistory();
  const [tabData, setTabData] = useState<Array<any>>([]);
  const [searchText, setSearchText] = useState("");
  const [selectedTabId, setSelectedTabId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpenModalTab, setOpenModalTab] = useState(false);
  const toggleModalTab = () => setOpenModalTab(!isOpenModalTab);
  useEffect(() => {
    fetchTabData();
  }, []);
  const fetchTabData = async () => {
    setLoading(true);
    const res = await api.getTabs();
    if (res.status === "ok") {
      setTabData(res.studio_tabs);
    }
    setLoading(false);
  };
  const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    userSelect: "none",
    // change background colour if dragging
    // background: isDragging ? 'var(--color-highlight-action)' : 'none',
    ...draggableStyle,
  });
  const renderTab = (tab: any, index: number) => {
    return (
      <Draggable
        key={tab.id}
        draggableId={`${tab.id}`}
        index={index}
        isDragDisabled={searchText != ""}
      >
        {(dragProvided, dragSnapshot) => {
          return (
            <div
              ref={dragProvided.innerRef}
              {...dragProvided.draggableProps}
              {...dragProvided.dragHandleProps}
              style={getItemStyle(
                dragSnapshot.isDragging,
                dragProvided.draggableProps.style
              )}
            >
              <TabItem
                tab={tab}
                onClick={() => {
                  history.push(`/settings/custom-field/${tab.id}`);
                }}
                onEditTab={() => {
                  setSelectedTabId(tab.id);
                  toggleModalTab();
                }}
                onDuplicate={async () => {
                  const res = await api.createTab({
                    content_type: "site",
                    languages: {
                      vi: `${tab.name} copy`,
                      en: `${tab.name} copy`,
                    },
                    name: `${tab.name} copy`,
                  });
                  if (res.status === "ok") onTabCreated(res.studio_tab);
                }}
              />
            </div>
          );
        }}
      </Draggable>
    );
  };
  const onTabCreated = (tab: any) => {
    setTabData((data: any) => [...data, tab]);
  };
  const onDragEnd = (result: any) => {
    const { draggableId, source, destination } = result;
    if (!destination?.droppableId || destination.index === source.index) return;
    const newTab = sortNewGroup(result, tabData);
    const orderData = {
      content_type: "site",
      studio_tab_ids: newTab.map((t) => t.id),
    };
    api.orderTab(orderData);
    setTabData(newTab);
  };
  const tabs = () => {
    if (searchText) {
      return tabData.filter((t) =>
        t.name.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    return tabData;
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Container>
        <div className="page-header">
          <span className="page-title">{t().custom_tab__title}</span>
          <Button
            label={t().modal_create_tab__create_tab}
            type="primary"
            size="small"
            icon="add"
            onClick={toggleModalTab}
          />
        </div>
        <TextField
          style={{ marginTop: 10, maxWidth: 300, marginLeft: 10 }}
          type="outline"
          placeholder={t().custom_tab__title_placeholder}
          icon="search"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <div className="page-body__wrapper">
          <Droppable droppableId="custom-group" type="tab">
            {(provided, snapshot) => {
              return (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="page-body__tab"
                >
                  {tabs()?.map(renderTab)}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </div>
        <ModalCreateTab
          isOpen={isOpenModalTab}
          toggle={toggleModalTab}
          user={user}
          selectedTabId={selectedTabId}
          onClosed={() => {}}
          onCreated={onTabCreated}
          onDeleted={fetchTabData}
          onUpdated={fetchTabData}
        />
      </Container>
    </DragDropContext>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(CustomTabs);
